import { LatestVersion } from "../../../../content/payments/02-01-universal-checkout/latestVersion";
import * as React from 'react';
export default {
  LatestVersion,
  React
};